<template>
  <div class="c-ui-switcher d-flex align-items-center">
    <span
      v-if="label"
      class="c-ui-switcher__label w-medium me-2 d-none d-md-block">{{ label }}</span>
    <input
      v-model="state_intern"
      :id="`switcher-${id}`"
      class="c-ui-switcher__input d-none"
      type="checkbox"
      @change="update()"
    />
    <label :for="`switcher-${id}`" class="c-ui-switcher__walk"></label>
  </div>
</template>

<script>
export default {
  data() {
    return {
      state_intern: false,
    };
  },
  props: ['id', 'state', 'label'],
  watch: {
    state() {
      this.state_intern = this.state;
    },
  },
  mounted() {
    this.state_intern = this.state;
  },
  methods: {
    update() {
      this.$emit('update:state', this.state_intern);
    },
  },
};
</script>
